export default __webpack_public_path__ + "static/media/studentLibraryEntryCount.91f025e2.png";